import { fuseSignAxiosClient } from '@/lib';
import { withLogger } from '@/utils';

import { fuseSignUrls } from '../data';

type Return = {
  message: string;
  redirect_url: string;
};

export type getFuseSignConnect = {
  return: Return;
};

export type getFuseSignDisconnect = {
  return: Return;
};

export const getFusesignConnect = withLogger(async (): Promise<Return> => {
  const response = await fuseSignAxiosClient.get<Promise<Return>>(
    fuseSignUrls.fusesignConnect,
  );
  return response.data;
});

export const getFusesignDisconnect = withLogger(async (): Promise<Return> => {
  const response = await fuseSignAxiosClient.post<Promise<Return>>(
    fuseSignUrls.fusesignDisconnect,
  );
  return response.data;
});
